import { useState } from 'react';
import { Box } from '@mui/material';

import THEME from '../../../constants/theme';
import ContactModal from '../ContactModal';

/**
 * ContactCTAButton renders a primary CTA button that opens the ContactModal.
 * @param {Object} props - Component props.
 * @param {string} [props.label] - Button text (default: 'Schedule Your meeting').
 * @param {Object} [props.sx] - MUI sx prop for styling overrides.
 * @param {React.ReactNode} [props.children] - Button content.
 * @returns {JSX.Element} Button that triggers the contact modal.
 */
const ContactCTAButton = ({
  label = 'Schedule Your meeting',
  sx,
  children
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        component='button'
        onClick={() => setOpen(true)}
        sx={{
          display: 'inline-block',
          backgroundColor: THEME.COLORS.PRIMARY_BLUE,
          color: THEME.COLORS.NEUTRAL_WHITE,
          fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.PRIMARY,
          fontWeight: THEME.TYPOGRAPHY.FONT_WEIGHT.SEMI_BOLD,
          padding: `${THEME.SPACING.MEDIUM} ${THEME.SPACING.XL}`,
          textTransform: 'none',
          fontSize: '1rem',
          borderRadius: THEME.BORDERS.RADIUS.MEDIUM,
          transition: `all ${THEME.TRANSITIONS.MEDIUM}`,
          textDecoration: 'none',
          border: 'none',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: THEME.COLORS.PRIMARY_BLUE_HOVER || '#0028cc',
            transform: 'translateY(-2px)',
            boxShadow: `0 4px 12px ${THEME.COLORS.PRIMARY_BLUE}40`
          },
          ...sx
        }}
      >
        {children || label}
      </Box>
      <ContactModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ContactCTAButton;
